module.exports = __webpack_public_path__ + "static/media/freelancer-highlight-3.630536b8.webp";